<div [ngClass]="isMobile ? 'h-[100vh]' : 'min-h-[700px] max-h-[700px]'" class="app-container" #appContainer>
	<div class="q2-content" [ngClass]="{ 'rounded-3xl': isDesktop }" #mobileView>
		<div fxLayout="column" style="max-height: -webkit-fill-available; height: 100%; width: 100%">
			<mat-dialog-content class="drawer-top" [ngClass]="{ 'rounded-3xl': isDesktop || isTablet }" style="padding: 0px" fxLayout="column" #mobileDialogView>
				<web-modal-action #modalAction [isRecording]="isRecording" [startAnimation]="startAnimation" [notification]="notification" [ctaWidth]="ctaWidth" (closeModal)="closeModal.emit()"></web-modal-action>
				<div fxFlex class="mid-section" fxLayout="column">
					<div fxFlex class="cta-section" #videoAction>
						<web-cta #modalAction [activeScreen]="activeScreen" [isRecording]="isRecording" [startAnimation]="startAnimation" [finishedResponding]="finishedResponding" [notification]="notification" [ctaWidth]="ctaWidth" [channel]="channel"></web-cta>
					</div>
				</div>
				<div class="video-container">
					<video #displayedVideo [controls]="false" autoplay="true" class="video" controlsList="nodownload" playsinline hidden="true" [muted]="true"></video>
					<ng-container *ngIf="!isRecording; else recording">
						<div style="align-items: center" class="audio-container">
							<ng-lottie [options]="audioOptions" (animationCreated)="animationCreated($event)" height="auto" maxHeight="50px" width="100%" class="audio-lottie-button"></ng-lottie>
						</div>
					</ng-container>

					<ng-template #recording>
						<div style="align-items: center" class="audio-container">
							<ng-lottie [@fadeIn]="isRecording ? '*' : 'void'" [options]="audioPlayingOptions" (animationCreated)="animationCreated($event)" height="auto" maxHeight="50px" width="100%" class="audio-lottie-button"></ng-lottie>
						</div>
					</ng-template>
				</div>
				<div class="response-footer" fxLayout="column" #videoAction>
					<div style="align-items: center; width: 100%" fxLayout="column">
						<web-toggler [maxVideoTime]="notification.maxVideoLength" [activeScreen]="activeScreen" [isRecording]="isRecording" [startAnimation]="startAnimation" [finishedResponding]="finishedResponding" (setActiveScreen)="setActiveScreen.emit($event)"></web-toggler>
					</div>
					<div class="response-actions" fxLayout="row">
						<web-response-actions [isRecording]="isRecording" [startAnimation]="startAnimation" [isMobile]="isMobile" [audioMode]="audioMode" [options]="options" (startResponse)="startStreaming()" (stopResponse)="stopStreaming()"></web-response-actions>
					</div>
				</div>
			</mat-dialog-content>
		</div>
	</div>
</div>
